import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ComponentNames } from '@core/const';
import { Step } from '@main/mobile-menu/const';
import { MobileMenuFacade } from '@main/mobile-menu/data-access';
import { Observable } from 'rxjs';

@Component({
  selector: 'sd-mobile-menu-step',
  templateUrl: './mobile-menu-step.component.html',
  imports: [NgIf, AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileMenuStepComponent implements OnInit {
  @Input() componentName: ComponentNames;

  currentStep$: Observable<Step | null>;

  constructor(private mobileMenuFacade: MobileMenuFacade) {}

  ngOnInit(): void {
    this.currentStep$ = this.mobileMenuFacade.getCurrentStep();
  }
}
